// Prompt pinning (2026-10-23): every Mari experiment runs on ONE florence-prompts commit, resolved by the
// server at launch (the optional "Prompts commit" field; empty = the commit on main at launch time).
// Pure helpers for the launch form, the experiment header and run provenance. Unit-tested.

export const PROMPTS_REPO_URL = "https://github.com/adrit-hekavor/florence-prompts";

export const isSha = (s) => typeof s === "string" && /^[0-9a-f]{7,40}$/i.test(s);

// 8-character display form of a commit SHA ("" when absent).
export const shortSha = (sha) => (isSha(sha) ? sha.slice(0, 8).toLowerCase() : "");

// GitHub commit page for a full or short SHA (null when absent / not a SHA).
export const commitUrl = (sha) => (isSha(sha) ? `${PROMPTS_REPO_URL}/commit/${sha.toLowerCase()}` : null);

// Launch body field: trimmed ref, or undefined (= the server pins the current main).
export const promptsRefParam = (raw) => {
  const v = (raw || "").trim();
  return v ? v : undefined;
};

export const PREPARING_LABEL = "Preparing prompts…";

// Experiment-level prompts state → {label, tone, title} for a chip, or null when nothing to flag
// (ready → the commit link is shown instead; null status → an older / history-only experiment).
export function promptsStatusChip(exp) {
  const st = exp && exp.prompts_status;
  if (st === "preparing") return { label: PREPARING_LABEL, tone: "warn", title: `Pinning florence-prompts ${exp.prompts_ref || "main"}` };
  if (st === "failed") return { label: "Prompts failed", tone: "bad", title: exp.prompts_error || "Preparing prompts failed" };
  if (st === "cancelled") return { label: "Prompts cancelled", tone: "n", title: "Cancelled while preparing prompts" };
  return null;
}
